<template>
  <v-select
    ref="controlFocoSelectPuntoVenta"
    label="Punto de Venta*"
    v-model="iModel"
    :items="items"
    item-value="Id_PuntoVenta"
    item-text="Nombre"
    :rules="rules"
    :readonly="readonly"
    :loading="loading"
  >
    <template v-slot:no-data
      >No hay datos para mostrar</template
    >
    <template v-slot:progress>
      <v-progress-circular color="blue" indeterminate></v-progress-circular>
    </template>
  </v-select>
</template>

<script>
import HttpHelper from "@/store/HttpHelper";
import { eventBus } from "@/main";
export default {
  name: "SelectPuntoVenta",
  props: {
    model: Number,
    rules: {},
    readonly: Boolean
  },
  data() {
    return {
      items: [],
      loading: false
    };
  },
  computed: {
    iModel: {
      get() {
        return this.model;
      },
      set(valor) {
        if (valor != undefined && valor != 0) {
          var ind = this.items.findIndex(x => x.Id_PuntoVenta == valor);
          this.$emit("seleccionarItem", this.items[ind]);
        }
      }
    }
  },
  created() {
    eventBus.$on("setearFocoSelectPuntoVenta", this.setearFoco);
    eventBus.$on("inicializarSelectPuntoVenta", this.inicializar);
    this.inicializar();
  },
  beforeDestroy() {
    eventBus.$off("setearFocoSelectPuntoVenta", this.setearFoco);
    eventBus.$off("inicializarSelectPuntoVenta", this.inicializar);
  },
  methods: {
    inicializar() {
      this.items = [];
      this.listarItems();
    },
    listarItems() {
      this.loading = true;
      HttpHelper.get("PuntoVenta/ListarSelect")
        .then(response => {
          this.items = response.data;
          if (this.items.length > 0) this.iModel = this.items[0].Id_PuntoVenta;
          this.loading = false;
        })
        .catch(error => {
          return Promise.reject(error);
        });
    },
    setearFoco() {
      this.$refs.controlFocoSelectPuntoVenta.focus();
    }
  }
};
</script>
